export enum DatePickerType {
  HOUR = 'H',
  DAY = 'D',
  MONTH = 'M',
}
